import React, { useState, useEffect } from 'react';
import { EntidadeEntidade } from '../../../entidades';
import { Alert, Box, Col, Row, StaticField } from '@intech/web-ui';

import { LoadingComponent } from '../../../components/LoadingComponent';

interface IProps {
  entidade: EntidadeEntidade
}

export const DadosBancarios: React.FC<IProps> = ({
  entidade
}) => {

  const [AlertText, setAlertText] = useState<string>("");
  const [Entidade, setEntidade] = useState<EntidadeEntidade>();

  useEffect(() => {
    (async () => {
      try {
        setEntidade(entidade);
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        console.log(error);
        setAlertText(error);
      }

    })();
  }, []);

  function renderDadosBancarios() {
    if (Entidade !== undefined) {

      return (
        <Box title={"Dados Bancários"}>

          <Row>
            <Col>
              <StaticField
                value={Entidade.NUM_BANCO}
                title={"Banco"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Entidade.NUM_AGENCIA}
                title={"Agência"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Entidade.NUM_CONTA}
                title={"Conta"}
                labelPosition={"up"}
                inline
              />
            </Col>

          </Row>
        </Box>
      );
    }

    if (AlertText !== "") {
      return (
        <Alert type={"danger"}>
          {AlertText}
        </Alert>
      );
    }

    return <LoadingComponent />;
  }

  return renderDadosBancarios();
}